






























import { Observer } from 'mobx-vue'
import { get } from 'lodash-es'
import { Component, Provide, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '@/modules/sb-farm/viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {
    'staked-card': () => import('@/modules/sb-farm/components/staked-card.vue'),
    'farm-info': () => import('@/modules/sb-farm/components/farm-info.vue'),
    'stake-lp-calculator': () => import('@/modules/sb-farm/components/stake-lp-calculator.vue'),
    'stake-pair-calculator': () => import('@/modules/sb-farm/components/stake-pair-calculator.vue'),
    //dialog
    'apr-dialog': () => import('@/modules/sb-farm/dialogs/APR-dialog.vue'),
    'widthdraw-dialog': () => import('@/modules/sb-farm/dialogs/withdraw-dialog.vue'),
    'unstake-dialog': () => import('@/modules/sb-farm/dialogs/unstake-dialog.vue'),
    'increase-time-dialog': () => import('@/modules/sb-farm/dialogs/increase-time-dialog.vue'),
    'increase-lp-amount-dialog': () => import('@/modules/sb-farm/dialogs/increase-lp-amount-dialog.vue'),
    'increase-pair-amount-dialog': () => import('@/modules/sb-farm/dialogs/increase-pair-amount-dialog.vue'),
    'remove-liquidity-dialog': () => import('@/modules/sb-farm/dialogs/remove-liquidity-dialog.vue'),
    'lp-received-dialog': () => import('@/modules/sb-farm/dialogs/lp-recevied-dialog.vue')
  }
})
export default class extends Vue {
  @Provide() vm = new FarmingViewModel(get(this.$route, 'query.farmType'), get(this.$route, 'query.locktime'))
}
